import React from 'react';
import { FormattedMessage } from 'react-intl';
import { IconButton, Paper, Typography, type PaperProps } from '@mui/material';

import useSettings from '../../hooks/useSettings';
import Icon from '../../Icon';

type ModuleSearchPaperComponentProps = {
	options: any[];
	totalOptionsCount?: number;
	isLoading: boolean;
} & PaperProps;

interface ModuleSearchPopupIndicatorProps {
	handleOpenDialog: VoidFunction;
}

export const ModuleSearchPaperComponent = (props: ModuleSearchPaperComponentProps) => {
	const { options, totalOptionsCount, isLoading, children, ...componentProps } = props;
	const { t } = useSettings();

	if (!isLoading && (totalOptionsCount || 0) > 0)
		return (
			<Paper {...componentProps} variant="outlined">
				{children}
				<Typography
					className="p-8 text-right"
					variant="subtitle2"
					sx={theme => ({ borderTop: `1px solid ${theme.palette.divider}` })}
				>
					<FormattedMessage
						id="moduleSearchField.resultsCount"
						defaultMessage={t('MODULESEARCH_RESULTS_COUNT')}
						values={{ n: options?.length || 0, tot: totalOptionsCount }}
					/>
				</Typography>
			</Paper>
		);

	return <></>;
};

export const ModuleSearchPopupIndicator = (props: ModuleSearchPopupIndicatorProps) => (
	<IconButton className="p-2" size="small" tabIndex={-1} onClick={props.handleOpenDialog}>
		<Icon icon="search" size={20} />
	</IconButton>
);
